export function escapeQoutes(str) {
  return str.replace(/[\\""]/g, '\\"');
}
